import { render, staticRenderFns } from "./stepPrize.vue?vue&type=template&id=3738ceaa&scoped=true&"
import script from "./stepPrize.vue?vue&type=script&lang=js&"
export * from "./stepPrize.vue?vue&type=script&lang=js&"
import style0 from "./stepPrize.vue?vue&type=style&index=0&id=3738ceaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738ceaa",
  null
  
)

export default component.exports